import { useState } from 'react';
import { useCookieStore } from '../stores/cookieStore';
import { Cookie, ChevronDown, ChevronUp, ShieldCheck } from 'lucide-react';

export function CookieBanner() {
  const { bannerShown, acceptAll, acceptNecessary, setPreferences } = useCookieStore();
  const [showDetails, setShowDetails] = useState(false);
  const [functional, setFunctional] = useState(false);
  const [analytics, setAnalytics] = useState(false);

  if (!bannerShown) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-surface-1 border-t border-border shadow-lg">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-primary-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm text-text-primary font-medium">
              Utilizamos cookies estrictamente necesarias para el funcionamiento del software.
            </p>
            <p className="text-xs text-text-tertiary mt-1">
              No utilizamos cookies de terceros, analitica ni rastreadores.
              Consulta nuestra{' '}
              <a href="/cookies" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline">
                Politica de cookies
              </a>{' '}
              y{' '}
              <a href="/privacidad" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline">
                Politica de privacidad
              </a>.
            </p>

            {showDetails && (
              <div className="mt-3 space-y-2 bg-surface-0 rounded-lg border border-border p-3">
                <label className="flex items-center gap-3 text-sm text-text-secondary">
                  <input
                    type="checkbox"
                    checked
                    disabled
                    className="w-4 h-4 rounded border-border text-primary-600 opacity-60"
                  />
                  <span className="flex-1">
                    <strong className="text-text-primary">Necesarias</strong>{' '}
                    — Autenticacion y seguridad. No se pueden desactivar.
                  </span>
                  <ShieldCheck className="w-4 h-4 text-success-500 flex-shrink-0" />
                </label>
                <label className="flex items-center gap-3 text-sm text-text-secondary cursor-pointer">
                  <input
                    type="checkbox"
                    checked={functional}
                    onChange={(e) => setFunctional(e.target.checked)}
                    className="w-4 h-4 rounded border-border text-primary-600 focus:ring-primary-300"
                  />
                  <span>
                    <strong className="text-text-primary">Funcionales</strong>{' '}
                    — Preferencias de interfaz (idioma, tema).
                  </span>
                </label>
                <label className="flex items-center gap-3 text-sm text-text-secondary cursor-pointer">
                  <input
                    type="checkbox"
                    checked={analytics}
                    onChange={(e) => setAnalytics(e.target.checked)}
                    className="w-4 h-4 rounded border-border text-primary-600 focus:ring-primary-300"
                  />
                  <span>
                    <strong className="text-text-primary">Analiticas</strong>{' '}
                    — Metricas de uso anonimas para mejorar el software.
                  </span>
                </label>
              </div>
            )}

            <div className="flex flex-wrap items-center gap-2 mt-3">
              <button
                onClick={() => {
                  if (showDetails) {
                    setPreferences({ necessary: true, functional, analytics });
                  } else {
                    acceptAll();
                  }
                }}
                className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium rounded-lg transition-colors"
              >
                {showDetails ? 'Guardar preferencias' : 'Aceptar todas'}
              </button>
              <button
                onClick={acceptNecessary}
                className="px-4 py-2 bg-surface-2 hover:bg-surface-3 text-text-secondary text-sm font-medium rounded-lg transition-colors border border-border"
              >
                Solo necesarias
              </button>
              <button
                onClick={() => setShowDetails(!showDetails)}
                className="px-4 py-2 text-text-tertiary text-sm hover:text-text-secondary transition-colors flex items-center gap-1"
              >
                {showDetails ? (
                  <>
                    Ocultar opciones <ChevronUp className="w-4 h-4" />
                  </>
                ) : (
                  <>
                    Configurar <ChevronDown className="w-4 h-4" />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
